import _defineProperty from "/home/keoadmin/agent/_work/119/s/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/keoadmin/agent/_work/119/s/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { objectToSearchString } from "./objectToSearchString";
import { searchStringToObject } from ".";
var JSON_SAFE_CHARS = "{}[],\":".split("").map(function (d) {
  return [d, encodeURIComponent(d)];
});
function getHrefFromLocation(location, search) {
  var href = search;
  if (location.href) {
    try {
      var url = new URL(location.href);
      href = "".concat(url.origin).concat(url.pathname).concat(search);
    } catch (e) {
      href = "";
    }
  }
  return href;
}
function transformSearchStringJsonSafe(searchString) {
  var str = searchString;
  var _iterator = _createForOfIteratorHelper(JSON_SAFE_CHARS),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        char = _step$value[0],
        code = _step$value[1];
      str = str.replace(new RegExp("\\" + code, "g"), char);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return str;
}
function updateLocation(encodedQuery, location) {
  var objectToSearchStringFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : objectToSearchString;
  var encodedSearchString = objectToSearchStringFn(encodedQuery);
  var search = encodedSearchString.length ? "?".concat(encodedSearchString) : "";
  var newLocation = _objectSpread(_objectSpread({}, location), {}, {
    key: "".concat(Date.now()),
    href: getHrefFromLocation(location, search),
    search: search,
    query: encodedQuery
  });
  return newLocation;
}
function updateInLocation(encodedQueryReplacements, location) {
  var objectToSearchStringFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : objectToSearchString;
  var searchStringToObjectFn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : searchStringToObject;
  var currQuery = searchStringToObjectFn(location.search);
  var newQuery = _objectSpread(_objectSpread({}, currQuery), encodedQueryReplacements);
  return updateLocation(newQuery, location, objectToSearchStringFn);
}
export { transformSearchStringJsonSafe, updateInLocation, updateLocation };